export const SET_SITE_INFO = 'site/SET_SITE_INFO';

export const setSiteInfo = payload => ({ type: SET_SITE_INFO, payload });



// WEBPACK FOOTER //
// ./app/actions/set-site-info.js